(function () {
  'use strict';
  if (customElements.get('ticker-bar')) return;
  customElements.define('ticker-bar', class extends HTMLElement {
    constructor() {
      super();
      this.resizeEvent = window.theme.debounce(() => this.checkWidth(), 100);
      this.motionChange = () => this.checkWidth();
    }
    connectedCallback() {
      this.autoplay = this.hasAttribute('data-autoplay');
      this.scale = this.querySelector('[data-ticker-scale]');
      this.text = this.querySelector('[data-ticker-text]');
      if (!this.scale || !this.text) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.comparitor = this.decorativeCopy();
      this.comparitor.classList.add('ticker__comparitor');
      this.appendChild(this.comparitor);
      this.pauseButton = document.createElement('button');
      this.pauseButton.type = 'button';
      this.pauseButton.className = 'ticker__pause';
      this.pauseButton.textContent = window.theme.strings.pause_ticker;
      this.pauseButton.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        this.pauseButton.textContent = paused ? window.theme.strings.resume_ticker : window.theme.strings.pause_ticker;
      });
      this.appendChild(this.pauseButton);
      this.scale.classList.remove('ticker--unloaded');
      window.addEventListener('orientationchange', this.resizeEvent);
      document.addEventListener('theme:resize:width', this.resizeEvent);
      this.motion.addEventListener('change', this.motionChange);
      this.frame = requestAnimationFrame(() => this.checkWidth());
    }
    decorativeCopy() {
      const copy = this.text.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
      copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(element => element.setAttribute('tabindex', '-1'));
      return copy;
    }
    checkWidth() {
      if (!this.isConnected || !this.scale || !this.comparitor) return;
      this.scale.querySelectorAll('[data-clone]').forEach(copy => copy.remove());
      const styles = window.getComputedStyle(this);
      const available = this.clientWidth - parseFloat(styles.paddingLeft || 0) - parseFloat(styles.paddingRight || 0);
      const width = this.comparitor.clientWidth;
      const animate = !this.motion.matches && width > 0 && (this.autoplay || available < width);
      this.text.classList.toggle('ticker--animated', animate);
      this.pauseButton.hidden = !animate;
      if (!animate) return;
      const count = Math.min(12, Math.max(1, Math.ceil(available / width)));
      for (let index = 0; index < count; index++) {
        const copy = this.decorativeCopy();
        copy.setAttribute('data-clone', '');
        this.scale.appendChild(copy);
      }
      const speed = Math.max(1, parseInt(this.getAttribute('data-marquee-speed'), 10) || 100);
      this.scale.style.setProperty('--animation-time', `${1.63 * width / speed}s`);
      this.querySelectorAll('[data-aos]').forEach(element => element.classList.add('aos-animate'));
    }
    disconnectedCallback() {
      window.removeEventListener('orientationchange', this.resizeEvent);
      document.removeEventListener('theme:resize:width', this.resizeEvent);
      this.motion?.removeEventListener('change', this.motionChange);
      cancelAnimationFrame(this.frame);
      this.scale?.querySelectorAll('[data-clone]').forEach(copy => copy.remove());
      this.comparitor?.remove();
      this.pauseButton?.remove();
    }
  });
})();
